import React from 'react';
import cn from 'classnames';

import Section from 'react-scale/components/elements/section';
import CTA from 'react-scale/components/elements/cta';
import { SingleFieldHSForm } from 'react-scale/components/elements/hubspot/single-field-form';

const SimpleCentered = ({
  theme,
  title,
  useHubSpotCTA = true,
  cta,
  formId = '',
  border,
  themeColors
}) => (
  <div className={cn({ 'border-t': border }, borderTheme[theme])}>
    <Section bg={cn(bgTheme[theme])} center>
      <div className="flex flex-col items-center justify-center">
        <h2 className={cn('mb-8 text-3xl font-aeonik', text[theme])}>{title}</h2>
        <div className="flex w-full sm:w-auto justify-center">
          {useHubSpotCTA && cta ? (
            <CTA theme={theme} cta={cta} themeColors={themeColors?.buttons} />
          ) : (
            <SingleFieldHSForm centered formInstanceId="pre-footer" id={formId} />
          )}
        </div>
      </div>
    </Section>
  </div>
);

const borderTheme = {
  dark: 'border-neutral-800',
  light: 'border-neutral-200'
};

const bgTheme = {
  dark: 'bg-black',
  light: 'bg-transparent'
};

const text = {
  dark: 'text-white',
  light: 'text-black',
  blacknwhite: 'text-gradient-white uppercase !text-base !font-body tracking-[4px]'
};

SimpleCentered.defaultProps = {
  theme: 'dark',
  themeColors: undefined,
  title: 'Get Started Today',
  border: false,
  cta: undefined,
  sectionProps: undefined
};

export default SimpleCentered;
